import axios from "axios";
import settings from "../settings";
import moment from "moment";

let initialState = {
    requestSuccess: false,
    requestError: false,
    drawerOpen: false,
    errorMessage: "",
    google: null,
    map: null,
    showLoader: false,
    searchShopString: "",
    startDate: new Date(2020, 0, 1),
    endDate: new Date(),
    shops: []
};
export default {
    namespaced: true,
    state: { ...initialState },
    actions: {
        async getShopsCoordinates({ commit, state }, { search, start_date, end_date }) {
            if (!state.showLoader) {
                // To avoid multiple queries
                commit("startLoader");
                try {
                    let params = {
                        search: search ? search : "",
                        start_date: start_date ? start_date : null,
                        end_date: end_date ? end_date : null
                    };
                    let response = await axios.get(settings.api_url + "/shops-map/", { params });
                    if (response.status === 200 && response.data.success === 1) {
                        let data = response.data;
                        commit("addShops", data.shops);
                    }
                } catch (e) {
                    console.log(e);
                }
                setTimeout(function() {
                    commit("stopLoader");
                }, 500);
            }
        },
        async callGetShopCoordinates({ state, dispatch }) {
            await dispatch("getShopsCoordinates", {
                search: state.searchShopString,
                start_date: state.startDate ? moment(state.startDate).format("YYYY-MM-DD") : null,
                end_date: state.endDate ? moment(state.endDate).format("YYYY-MM-DD") : null
            });
        }
    },
    mutations: {
        setRequestSuccess(state, bool) {
            state.requestSuccess = bool;
        },
        setErrorMessage(state, message) {
            state.errorMessage = message;
        },
        toggleDrawer(state, isOpen) {
            state.drawerOpen = isOpen;
        },
        setMap(state, val) {
            state.map = val;
        },
        setGoogle(state, val) {
            state.google = val;
        },
        stopLoader(state) {
            state.showLoader = false;
        },
        startLoader(state) {
            state.showLoader = true;
        },
        addShops(state, value) {
            state.shops = value;
        },
        updateShopSearch(state, payload) {
            state.searchShopString = payload.term;
            this.dispatch("ShopsMapStore/callGetShopCoordinates");
        },
        resetShopSearch(state) {
            state.searchShopString = "";
        },
        setStartDate(state, value) {
            state.startDate = moment(value).toDate();
            this.dispatch("ShopsMapStore/callGetShopCoordinates");
        },
        setEndDate(state, value) {
            state.endDate = moment(value).toDate();
            this.dispatch("ShopsMapStore/callGetShopCoordinates");
        },
        resetMapAndGoogle(state) {
            state.google = null;
            state.map = null;
        }
    },
    getters: {
        shopsCount: state => {
            return state.shops.length;
        }
    }
};
